<template>
  <div key="modalKey">
    <el-tooltip :content="$t('reportingProfiles.addUserToProfile.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom"
                class="float-right">
      <base-button size="md" icon round type="primary" @click="modal = true">
        <span class="mdi mdi_icon mdi-24px mdi-account-multiple-plus-outline"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg"
           showClose
           @close="resetForm()">
      <template slot="header">
        <h4 class="card-title d-inline">{{ $t('reportingProfiles.addUserToProfile.modalTitle') }}</h4>
      </template>
      <template>
        <account-search-wizard :hide-header="true" @processFoundAccount="addUser"
                               :hide-search-by-serial-number="true"
                               :process-error="reportingProfileError"
                               :search-step-reopened="resetProcessingError"/>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseRadio, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import AccountSearchWizard from 'src/pages/Account/AccountSearchWizard'

export default {
  name: 'add-user-to-reporting-report',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseRadio,
    AccountSearchWizard
  },
  data() {
    return {
      modal: false,
      modalKey: 1
    }
  },

  computed: {
    ...mapState({
      reportingProfileLoading: state => state.reporting_profile.loading,
      reportingProfileError: state => state.reporting_profile.error
    }),
  },

  methods: {
    ...mapActions(['AddAccountToReportingProfile', 'GetReportingProfile', 'ResetReportingProfileError']),
    addUser: function (foundAccountPayload) {
      const payload = {
        id: this.$route.params.id,
        account_id: foundAccountPayload.id,
      }
      this.AddAccountToReportingProfile(payload).then(() => {
        if (this.reportingProfileError == null) {
          this.$notify({
            type: 'success',
            message: this.$t('reportingProfiles.addUserToProfile.accountAddedNotification', {account_id: payload.account_id}),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.GetReportingProfile(this.$route.params.id)
          this.resetForm()
        }
      });
    },
    resetProcessingError: function () {
      // Reset error to null.
      this.ResetReportingProfileError()
    },
    resetForm: function () {
      // closing dialog
      this.modal = false
      this.resetProcessingError()
    },
  },
  destroyed() {
    // By changing the KEY of the component - Vue will trigger component render (all forms will be cleared).
    if (this.modalKey > 1) {
      --this.modalKey
    } else {
      ++this.modalKey
    }
  }
}
</script>
